import { createContext, useContext } from 'react';
import type { AdminImpersonation, ImpersonationStart } from './api';

export interface SupportSessionState {
  open: (result: ImpersonationStart) => Promise<void>;
  current: AdminImpersonation | null;
  error: string;
  busy: boolean;
  exit: () => Promise<void>;
}
export const SupportSessionContext = createContext<SupportSessionState | null>(null);
export function useSupportSessionSwitch() {
  const state = useContext(SupportSessionContext);
  if (!state) throw new Error('Support sessions require the application session provider.');
  return state.open;
}
export function useSupportSession() {
  return useContext(SupportSessionContext);
}
